// REGISTER GSAP PLUGINS
gsap.registerPlugin(ScrollTrigger);

// GSAP
document.addEventListener("DOMContentLoaded", (event) => {

  // Norsk theme values
  let norskHeaderHeight = document.querySelector('.header-section header-menu').offsetHeight;
  
  // Update header height on resize
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      norskHeaderHeight = document.querySelector('.header-section header-menu').offsetHeight;
    }, 150);
  });
    
  // gsap.com/docs/v3/GSAP/gsap.matchMedia()
  let mm = gsap.matchMedia();

  mm.add({
    isMobile: `(max-width: 47.999em)`, // up to 767.999px
    isTablet: `(min-width: 48em) and (max-width: 63.999em)`, // 768px - 1023.999px
    isDesktop: `(min-width: 64em)`, // 1024px
    reduceMotion: "(prefers-reduced-motion: reduce)",
  },
    (context) => {
      let { isDesktop, isTablet, isMobile, reduceMotion } = context.conditions;

      // common page vars
      let siteFooter = document.querySelector('#MainContent + footer');
      let norskFooter = document.querySelector('.footer__norsk-outer');


      // PAGES WITH BLOG GRADIENT AT TOP -----------------------------------------
      // Blogs, Contact, Quiz, etc.

      // BLOG GRADIENT
      let blogGradient = document.querySelector('.blog__gradient');
      if (blogGradient && norskFooter) {
        ScrollTrigger.create({
          trigger: norskFooter,
          start: 'top bottom',
          toggleClass: { targets: blogGradient, className: 'blog__gradient__hidden' },
          // markers: true
        });
      }

      // PHOTO CARD CAROUSEL (HOME ONLY) -----------------------------------------
      let homeHero = document.querySelector('body.page--index .photo-card-carousel__slider');
      if (homeHero) {
        ScrollTrigger.create({
          trigger: homeHero,
          start: () => `top top+=${norskHeaderHeight}`,
          end: 'bottom top-=10000px', // never unpin
          pin: true,
          pinSpacing: false,
          // markers: true
        });
      }
      
      // COLLECTIONS VIEWFINDER (HOME ONLY) -----------------------------------------
      let collectionsViewfinder = document.querySelector('body.page--index .shopify-section[id*=collections_viewfinder]');
      
      if (collectionsViewfinder) {
        // add space below to prevent next section from appearing too soon
        collectionsViewfinder.style.marginBlockEnd = '20svh';
      }
      
      if (collectionsViewfinder) {
        ScrollTrigger.create({
          trigger: collectionsViewfinder,
          start: 'top top',
          end: 'bottom top-=10000px', // never unpin
          pin: true,
          pinSpacing: false,
          anticipatePin: 1,
          // markers: true
        });
      }

      // PINNED COLUMNS (ALL) -----------------------------------------
      let pinnedCols = gsap.utils.toArray('.pinned-columns--inner .shopify-block');
      let pinnedColHeight = document.querySelector('.pinned-columns .shopify-block')?.offsetHeight || 0;
      let pinnedColDist = 0.1 * visualViewport.height;

      pinnedCols.forEach((pinnedcol) => {
        ScrollTrigger.create({
          trigger: pinnedcol,
          start: () => `top top+=${pinnedColDist}`,
          end: 'bottom top-=10000px', // never unpin
          pin: true,
          pinSpacing: false,
          anticipatePin: 1,
          // markers: true
        });
      });

      // PINNED COLUMNS LOGO ----
      // if [data-position="centered"] center it in available bottom space, otherwise pin to bottom
      let pinnedcolimg = document.querySelector('.pinned-columns-logo__image');
      if (pinnedcolimg) {
        ScrollTrigger.create({
          trigger: pinnedcolimg,
          start: () => {
            if (isMobile) return 'center center';
            if (pinnedcolimg.dataset.position === 'centered') {
              let available = visualViewport.height - pinnedColDist - pinnedColHeight;
              let availableCenter = available / 2;
              return `center bottom-=${availableCenter}px`;
            }
            return 'bottom bottom';
          },
          end: 'bottom top-=10000px', // never unpin
          pin: true,
          pinSpacing: false,
          anticipatePin: 1,
          // markers: true
        });
      }

      // PDP DESCRIPTION MIN HEIGHT ON MOBILE -----------------------------------------
      if (isMobile || isTablet) {
        let pdpDescription = document.querySelector('.product-info__description');
        if (pdpDescription) {
          ScrollTrigger.create({
            trigger: pdpDescription,
            start: 'bottom bottom',
            end: 'bottom top',
            pin: true,
            pinSpacing: false,
            anticipatePin: 1,
            // markers: true
          });
        }
      }

      // ABOUT HERO -----------------------------------------
      
      // top
      let aboutHero = document.querySelector('.about-hero__top');
      if (aboutHero) {
        ScrollTrigger.create({
          trigger: aboutHero,
          start: () => `top top+=${norskHeaderHeight}`,
          endTrigger: aboutHero.closest('.shopify-section').nextElementSibling,
          end: 'top top',
          pin: true,
          pinSpacing: false,
          anticipatePin: 1,
          // markers: true
        });
      }

      // bottom (mobile only)
      if (isMobile) {
        let aboutHeroBottomBlurb = document.querySelector('.about-hero__bottom__blurb');
        if (aboutHeroBottomBlurb) {
          ScrollTrigger.create({
            trigger: aboutHeroBottomBlurb,
            start: 'top top+=20%',
            endTrigger: aboutHero.closest('.shopify-section').nextElementSibling,
            end: 'top top',
            pin: true,
            pinSpacing: false,
            anticipatePin: 1,
            // markers: true
          });
        }
      }

      // ABOUT PAGE SECTIONS -----------------------------------------

      // Various
      let aboutSections = gsap.utils.toArray([
        '.shopify-section[id*="rich_text_columns_DM96y6"]', // north of ordinary
        '.shopify-section[id*="rich_text_columns_AxnELX"]', // made for more
        '.shopify-section[id*="rich_text_columns_Nb4f3f"]', // foundation
        '.shopify-section[id*="rich_text_columns_9eeyRQ"]', // faith in action
        '.shopify-section[id*="rich_text_columns_wAL7bW"]', // looking ahead
      ]);
      aboutSections.forEach((section, index) => {
        let isLastSection = index === aboutSections.length - 1;
        ScrollTrigger.create({
          trigger: section,
          start: 'top top',
          endTrigger: isLastSection ? 'body > footer' : section.nextElementSibling,
          end: 'top top',
          pin: true,
          pinSpacing: false,
          anticipatePin: 1,
          // markers: true
        });
      });

      // North of Ordinary: special bg fade out before it unpins because it annoyingly peeks through sometimes
      let madeForMoreTrigger = document.querySelector('.shopify-section[id*="rich_text_columns_AxnELX"]');
      let northOfOrdinaryBg = document.querySelector('.shopify-section[id*="rich_text_columns_DM96y6"] [data-color-scheme]');
      if (madeForMoreTrigger) {
        ScrollTrigger.create({
          trigger: madeForMoreTrigger,
          start: 'top top+=100px',
          end: 'bottom top',
          onEnter: () => northOfOrdinaryBg.style.background = 'white',
          onLeave: () => northOfOrdinaryBg.style.background = null,
          onEnterBack: () => northOfOrdinaryBg.style.background = 'white',
          onLeaveBack: () => northOfOrdinaryBg.style.background = null,
          // markers: true
        });
      }

      // Open Positions - left column
      if (isDesktop || isTablet) {
        let openPositionsText = document.querySelector('.shopify-section[id*="rich_text_columns_BDVtLz"] .rich-text__blocks:first-child');
        let openPositionsTextHeight = openPositionsText ? openPositionsText.offsetHeight : 200;
        if (openPositionsText) {
          ScrollTrigger.create({
            trigger: openPositionsText,
            start: 'top top+=200px',
            end: `bottom top+=${openPositionsTextHeight + 400}px`,
            endTrigger: openPositionsText.closest('.shopify-section'),
            pin: true,
            pinSpacing: false,
            anticipatePin: true,
            // markers: true
          });
        }
      }
      

      // ECO-FRIENDLY PAGE -----------------------------------------
      
      // Header ----
      // same for desktop/tablet/mobile except for offset depending
      let ecoHeader       = document.querySelector('body.page--page-ecofriendly [id*="__section_header_QhhVTK"] .content-header');
      let ecoHeaderHeight = ecoHeader ? ecoHeader.offsetHeight : 0;
      let ecoStartDist = isDesktop ? norskHeaderHeight + 100 : norskHeaderHeight + 40;

      if (ecoHeader) {
        ScrollTrigger.create({
          trigger: ecoHeader,
          start: () => `top top+=${ecoStartDist}`,
          endTrigger: norskFooter,
          end: 'top top',
          toggleClass: { targets: 'html', className: 'eco-header-pinned' },
          pin: true,
          pinSpacing: false,
          anticipatePin: 1,
          // markers: true,
        });
      }

      // Recyling Process sections ----

      // mobile
      if (isMobile) {

        let ecoSections = gsap.utils.toArray('body.page--page-ecofriendly #MainContent > [id*="image_with_text"]');
        ecoSections.forEach((section) => {
          ScrollTrigger.create({
            trigger: section,
            start: () => `top top+=${ecoStartDist}px`,
            endTrigger: siteFooter,
            end: 'bottom top', // never unpin
            pin: true,
            pinSpacing: false,
            anticipatePin: 1,
            // markers: true,
          });
        });

      }
      
      // desktop (section headings only)
      if (isDesktop || isTablet) {

        let ecoSectionHeads = gsap.utils.toArray('body.page--page-ecofriendly #MainContent > [id*="image_with_text"] .rich-text__blocks:first-child .heading');
        let cumulativeOffset = ecoStartDist + ecoHeaderHeight; // starting position for first item
        ecoSectionHeads.forEach((section) => {
          ScrollTrigger.create({
            trigger: section,
            start: `top top+=${cumulativeOffset}px`,
            endTrigger: siteFooter,
            end: 'bottom top', // never unpin
            pin: true,
            pinSpacing: false,
            anticipatePin: 1,
            // markers: true,
          });
          
          // Add this section's height to cumulative offset for next section
          cumulativeOffset += section.offsetHeight + 30;
        });

        // trigger to show/hide bottom desktop gradient
        let sectionAfterLastEcoSection = document.querySelector('.shopify-section[id*="custom_liquid_RLHPbk"]');
        if (sectionAfterLastEcoSection) {
          ScrollTrigger.create({
            trigger: sectionAfterLastEcoSection,
            start: 'top bottom',
            end: 'bottom top',
            toggleClass: { targets: 'html', className: 'eco-completed' },
            // markers: true
          });
        }

      } // end isDesktop (sections of ecofriendly)


      // INSTALLATION GUIDES HERO -----------------------------------------
      
      if (isMobile || isTablet) {
        let installGuidesHero = gsap.utils.toArray([
          '.shopify-section[id*="rich_text_h4jPkE"]', // foam
          '.shopify-section[id*="rich_text_MVywPE"]', // pvc
        ]);
        
        const createInstallGuideScrollTriggers = () => {
          installGuidesHero.forEach((section) => {
            ScrollTrigger.create({
              trigger: section,
              start: () => `top top+=${norskHeaderHeight}`,
              end: 'bottom top',
              pin: true,
              pinSpacing: false,
              // markers: true,
            });
          });
        };
        
        // Creating after a tick because ST was doing weird layout things to section in this instance
        requestAnimationFrame(createInstallGuideScrollTriggers);

      }


      // LEGAL PAGE TABLE OF CONTENTS -----------------------------------------
      
      if (document.body.classList.contains('page--page-legal') && document.getElementById('MainContent')?.dataset.disableToc !== 'true') {
        if (isTablet || isDesktop) {

          let legalToc = document.querySelectorAll('.legal-toc');
          let legalTocParent = legalToc[0]?.closest('.rich-text__blocks');
          let legalContainer = legalToc[0]?.closest('.shopify-section');

            ScrollTrigger.create({
              trigger: legalTocParent,
              start: () => `top top+=${norskHeaderHeight + (isDesktop ? 100 : 20)}`,
              endTrigger: legalContainer,
              end: 'bottom bottom',
              pin: true,
              pinSpacing: false,
              anticipatePin: true,
              // markers: true
            });
        }
      }


    } // end of media query
  ); // end of mm.add()

}); // end DOMContentLoaded